import React from "react"
import WeekOverview from "./summarySection/WeekOverview"
import PatientSummary from "./summarySection/OverallPatientSummary"
import SchedulingIssues from "./summarySection/SchedulingIssues"

const FutureHuddleSummarySection = ({ futureHuddleData, settings }) => {
	return (
		<div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 mt-8">
			<WeekOverview futureHuddleData={futureHuddleData} settings={settings} />
			<PatientSummary futureHuddleData={futureHuddleData} settings={settings} />
			<SchedulingIssues futureHuddleData={futureHuddleData} settings={settings} />
		</div>
	)
}

export default React.memo(FutureHuddleSummarySection)
